import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditInstrumentsComponent } from 'src/app/pages/strategy/edit-instruments/edit-instruments.component';
import { NewStrategyComponent } from 'src/app/pages/strategy/new-strategy/new-strategy.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { DisabledInvestmentCreationGuard } from 'src/app/services/disabled-investment-creation.guard';
import { ExecutionOnlyGuardService } from 'src/app/services/execution-only-guard.service';

const routes: Routes = [
  {
    path: 'pick',
    loadChildren: () => import('../../modules/strategy-picker/strategy-picker.module').then(m => m.StrategyPickerModule),
    canActivate: [AuthenticationService, ExecutionOnlyGuardService, DisabledInvestmentCreationGuard],
  },
  {
    path: 'new',
    component: NewStrategyComponent,
    canActivate: [AuthenticationService, ExecutionOnlyGuardService, DisabledInvestmentCreationGuard],
  },
  {
    path: 'new/edit-instruments',
    component: EditInstrumentsComponent,
    canActivate: [AuthenticationService, ExecutionOnlyGuardService, DisabledInvestmentCreationGuard],
  },
  {
    path: 'new/:modelStrategyId',
    component: NewStrategyComponent,
    canActivate: [AuthenticationService, ExecutionOnlyGuardService, DisabledInvestmentCreationGuard],
  },
  {
    path: 'edit/:editStrategyId',
    component: NewStrategyComponent,
    canActivate: [AuthenticationService, ExecutionOnlyGuardService, DisabledInvestmentCreationGuard],
    data: { partialAccess: true }
  },
  {
    path: 'edit/:editStrategyId/edit-instruments',
    component: EditInstrumentsComponent,
    canActivate: [AuthenticationService, ExecutionOnlyGuardService, DisabledInvestmentCreationGuard],
    data: { partialAccess: true }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StrategyRoutingModule { }
